import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import * as Component from './MessageBox.styles'
import { Button } from 'components/atoms'
import { TextContext } from 'hocs'
import { hideAPIErrorInfo } from 'redux/actions/errorActions'
import { useDispatch } from 'react-redux'

const MessageBox = ({
  messageText,
  headline,
  children,
  showClose = true,
  isError = false,
  handleShow,
  show,
  ...rest
}) => {
  // console.log(props)

  const textContext = useContext(TextContext)
  const dispatch = useDispatch()

  const [visibility, setVisibility] = React.useState(true)
  const mergedShowState =
    (typeof handleShow === 'function' && show) || (!handleShow && visibility)

  // set default error texts if texts are empty
  if (isError) {
    headline = !headline ? textContext['error.default.headline'] : headline
    messageText = !messageText ? textContext['error.default.copy'] : messageText
  }

  const closeClickHandler = () => {
    // reset error
    if (isError) {
      dispatch(hideAPIErrorInfo())
    }

    if (typeof handleShow === 'function') {
      handleShow()
    } else {
      setVisibility((prevVisibility) => !prevVisibility)
    }
  }

  return (
    mergedShowState && (
      <Component.MessageBoxContainer
        isFlat
        className={
          isError ? 'container-content-error' : 'container-content-alternative'
        }
        { ...rest }>
        <Component.Text>
          {headline && <h4 className={ 'h4' }>{headline}</h4>}
          {messageText && messageText}
          {children && children}
        </Component.Text>
        {showClose && (
          <Button
            id='message-box-button'
            className='btn-alternative'
            text={ textContext['general.hide.info'] }
            onClick={ () => closeClickHandler() }
          />
        )}
      </Component.MessageBoxContainer>
    )
  )
}

MessageBox.defaultProps = {
  handleShow: false,
  show: true,
}

MessageBox.propTypes = {
  headline: PropTypes.string,
  messageText: PropTypes.string,
  /** Message Text */
  children: PropTypes.node,
  isError: PropTypes.bool,
  showClose: PropTypes.bool,
  /** handler for show overwrite **/
  handleShow: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
  show: PropTypes.bool,
}

export default MessageBox
